/**
 * All Permissions for System Administrator role
 */
export const SYSTEM_ADMINISTRATOR_PERMISSIONS: string[] = [
  'dashboardView',

  'terminalCreate',
  'terminalView',
  'terminalDetail',
  'terminalNotes',
  'terminalEdit',
  'terminalConfigure',
  'terminalConfigureEditable',
  'terminalRemove',
  'terminalAssign',
  'terminalTemplateApply',
  'terminalDownloadLogs',
  'terminalMaintenance',
  'terminalAuditLog',

  'terminalBulkTemplateApply',
  'terminalBulkActionRestart',
  'terminalBulkActionPushConfig',
  'terminalBulkActionPullConfig',
  'terminalBulkActionForcePushConfig',
  'terminalBulkActionResetConfig',
  'terminalBulkActionFactoryReset',
  'terminalBulkActionUpgradeConfig',
  'terminalBulkActionSetDomain',
  'terminalBulkActionSetAttribute',
  'terminalBulkActionSetType',
  'terminalBulkActionMigrateConfig',

  'terminalActionRestart',
  'terminalActionPushConfig',
  'terminalActionPullConfig',
  'terminalActionForcePushConfig',
  'terminalActionResetConfig',
  'terminalActionFactoryReset',
  'terminalActionUpgradeConfig',
  'terminalActionTerminalType',
  'terminalActionMigrateConfig',
  'terminalActionCryptoBind',
  'terminalActionCryptoAddDomain',
  'terminalActionCryptoRemoveDomain',
  'terminalAdvancedEdit',
  'terminalTransactions',

  'registrationCreate',
  'registrationView',
  'registrationEdit',
  'registrationFinalize',
  'registrationCancel',
  'registrationTRF',
  'registrationDeactivate',
  'registrationRemove',

  'transactionView',

  'eventView',
  'terminalEventSync',

  'deliveryCreate',

  'assetView',
  'administrationView',

  'domainView',
  'domainCreate',
  'domainEdit',
  'domainRemove',
  'domainContractTypeView',
  'domainContractTypeEdit',
  'domainTerminalTypeView',
  'domainTerminalTypeEdit',
  'domainDataView',
  'domainDataEdit',
  'domainAssetView',
  'domainAssetEdit',

  'roleView',
  'roleCreate',
  'roleCreateInheritable',
  'roleEdit',
  'roleRemove',

  'userView',
  'userCreate',
  'userEdit',
  'userRemove',
  'userPasswordRequest',
  'userFeatures',

  'templateView',
  'templateCreate',
  'templateEdit',
  'templateRemove',
  'templateConfigurationEdit',

  'notificationView',
  'notificationCreate',
  'notificationEdit',
  'notificationRemove',

  'contractCreate',
  'contractView',
  'contractEdit',
  'privateNotes',
  'contractRemove',
  'contractMerge',

  'taskView',
  'taskCreate',

  'terminalImport',
  'editNotes',

  'contractShowHidden',
  'serviceMenu',
]
